module.exports = __webpack_public_path__ + "static/media/Nutritionfactmatcha.3e8653fb.jpg";